import { QuestionType } from "./question.constants";
var ImageUploadContext;
(function (ImageUploadContext) {
    ImageUploadContext["PHOTO"] = "PHOTO";
    ImageUploadContext["INSPIRATION"] = "INSPIRATION";
})(ImageUploadContext || (ImageUploadContext = {}));
export { ImageUploadContext };
